export type WorkspaceRole = 'OWNER' | 'ADMIN';
export type WorkspaceType = 'PERSONAL';
export type EntitlementStatus = 'ACTIVE' | 'GRACE' | 'PAST_DUE' | 'EXPIRED' | 'CANCELLED' | 'REVOKED';

export type StudioFeature =
  | 'allSystems'
  | 'unlimitedCharts'
  | 'pdfDownload'
  | 'clientWorkspace'
  | 'chartComparison'
  | 'notifications';

export type FeatureMap = Record<StudioFeature, boolean>;

export type NumericLimits = {
  savedCharts: number | null;
  personalNotes: number | null;
  clients: number | null;
  videoStorageBytes: number | null;
  pdfExports?: number | null;
};

export type SeatUsage = {
  videoStorageBytes: number;
};

export type Entitlement = {
  status: EntitlementStatus;
  features: FeatureMap;
  limits: NumericLimits;
  usage?: Partial<NumericLimits & SeatUsage>;
};

export type Workspace = {
  id: string;
  name: string;
  type: WorkspaceType;
  plan?: {
    key: string;
    label: string;
    priceInr: number;
    seats?: Record<string, number | null>;
  };
  entitlement?: Entitlement;
};

export type WorkspaceMembership = {
  id: string;
  workspaceId: string;
  role: WorkspaceRole;
  workspace?: Workspace;
};

export type Invitation = {
  id: string;
  email?: string;
  role: WorkspaceRole;
  workspaceId: string;
  status: 'PENDING' | 'ACCEPTED' | 'CANCELLED' | 'EXPIRED';
};

export type StudioUser = {
  id: string;
  name: string;
  email: string;
  memberships?: WorkspaceMembership[];
  currentWorkspaceId?: string;
  preferences?: Record<string, any>;
};

export const DEFAULT_FEATURES: FeatureMap = {
  allSystems: false,
  unlimitedCharts: false,
  pdfDownload: false,
  clientWorkspace: true,
  chartComparison: false,
  notifications: true,
};

export const DEFAULT_LIMITS: NumericLimits = {
  savedCharts: 3,
  personalNotes: 3,
  clients: 1,
  videoStorageBytes: 0,
  pdfExports: 0,
};
